import styled from "styled-components";

import { StickyBarPage } from "../../../../components/SaveBar";

export const Container = styled(StickyBarPage)`
  gap: 0;
`;

/* Hint shown under a block while the form can't be saved yet */
export const Warning = styled.p`
  padding: 0.75rem 1rem;
  font-family: Inter, sans-serif;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-orange);
  background: rgba(255, 122, 0, 0.08);
  border-radius: 0.75rem;
`;

/* Where the answers go: one row per integration, like /settings' advanced options */
export const StorageList = styled.ul`
  overflow: hidden;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  li + li {
    border-top: 1px solid var(--color-neutral-base);
  }

  button {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    width: 100%;
    padding: 1rem 20px;
    text-align: left;
    transition: background-color 0.15s;

    &:hover {
      background: rgba(255, 255, 255, 0.03);
    }
  }

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
  }

  .title {
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;
    color: var(--color-neutral-white);
  }

  .description {
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
  }

  .active {
    display: inline-flex;
    flex-shrink: 0;
    gap: 0.375rem;
    align-items: center;
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--color-feedback-success);

    &::before {
      width: 6px;
      height: 6px;
      content: "";
      background-color: currentColor;
      border-radius: 100%;
    }
  }

  .chevron {
    display: flex;
    flex-shrink: 0;
    color: var(--color-neutral-150);
  }
`;
